export default "__VITE_ASSET__PIRl6XmA__"